export default __webpack_public_path__ + "static/sunilWadhwa3-7adc012c823ebd3c3ab6c630aa9b23b5.jpg";